module.exports = __webpack_public_path__ + "static/media/gamblingCom.1cb194a5.svg";